import React from "react";
import { DealShow } from "./DealShow";

const DealList = React.lazy(() => import("./DealList"));

export default {
  list: DealList,
  show: DealShow,
};
